import getIsLoyaltyEnabled from './getIsLoyaltyEnabled'

/**
 * Whether Société burn UX is enabled on experience search.
 * Uses the standard loyalty rollout gate (config), but not the Société burn
 * A/B test.
 */
function getIsExperienceLoyaltyBurnEnabled(state: App.State): boolean {
  return getIsLoyaltyEnabled(state)
}

export default getIsExperienceLoyaltyBurnEnabled
